import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal, Eyebrow } from "../lib/ui";

const POINTS = [
  {
    num: "01",
    title: "Tydelig kommunikation",
    text: "Vi forklarer juraen på en måde, der er til at forstå.",
  },
  {
    num: "02",
    title: "Fokus på din situation",
    text: "Rådgivningen tager udgangspunkt i den konkrete sag.",
  },
  {
    num: "03",
    title: "Nem kontakt",
    text: "Det skal være enkelt at komme i kontakt og komme videre.",
  },
  {
    num: "04",
    title: "Privat & erhverv",
    text: "Vi hjælper både privatpersoner og virksomheder.",
  },
];

export const WhyJuris = () => {
  const navigate = useNavigate();

  return (
  <section id="om-juris" className="scroll-mt-20 py-20 sm:py-28">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <Eyebrow>Om Juris</Eyebrow>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Juridisk rådgivning gjort mere tilgængelig
            </h2>
            <p className="mt-5 text-base leading-relaxed text-slate-600">
              Hos Juris mener vi, at det skal være nemmere at få overblik over juridiske
              spørgsmål. Derfor starter vi med at forstå din situation — og forklarer
              mulighederne i et klart og forståeligt sprog.
            </p>
            <button
              data-testid="why-cta"
              onClick={() => navigate("/kontakt")}
              className="group mt-8 inline-flex items-center gap-2 text-base font-semibold text-blue-600 transition-colors hover:text-blue-700"
            >
              Fortæl os om din sag
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7">
        {POINTS.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.06}>
            <div
              data-testid={`why-point-${i + 1}`}
              className="group grid grid-cols-[auto_1fr] items-start gap-6 border-t border-slate-200 px-2 py-9 transition-all duration-300 hover:bg-slate-50 hover:px-5 sm:gap-10 sm:py-10"
            >
              <span className="font-mono text-sm text-blue-600 sm:text-base">{p.num}</span>
              <div>
                <h3 className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl">
                  {p.title}
                </h3>
                <p className="mt-2 max-w-md text-base leading-relaxed text-slate-600">{p.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-slate-200" />
      </div>
    </div>
  </section>
  );
};

export default WhyJuris;